import React from 'react'
import Svg from 'react-inlinesvg'

type Props = {
  src: string,
  [key: string]: string | number,
}
const InlineSvg: React.FC<Props> = ({ src, ...rest }) => {
  // we need to replace the protocol of the src to match the current window location
  // otherwise we get a CORS error from react-inlinesvg
  const modifiedSrc = src.replace(/^https?:/, window?.location?.protocol)
  return <Svg src={modifiedSrc} {...rest} />
}

export default InlineSvg
